module.exports = function(service) {
	'use strict'
	service.factory('parseOptions', parseOptions);
	parseOptions.$inject = [];
	function parseOptions() {
	   return function (stringOptions) {
        var options = {}, set;
        if (!stringOptions) { return; }
        set = stringOptions
            .replace(/(\w+=")/g, '\n$1')
            .split('\n');
            set.shift();
  
        for (var i = 0; i < set.length; i++) {
            var kv = set[i].split('="');
            options[kv[0]] = kv[1].replace(/\'|\"/g, '').trim();
        }
        return options;
      };
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/parseOptionsService.js
// module id = 619
// module chunks = 0